import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Global from '../../../../../store/global-selectors';
import style from '../../../batch-components.module.less';

export const AssignedUser = ({ userId = '', className = '' }) => {
  const users = useSelector(Global.selectSellerUsers);
  const user = users.find((aUser) => aUser.userId === userId);
  return (
    <div className={classnames(style.user, className)}>
      {user ? (
        <div className={style.assigned}>{user.name}</div>
      ) : (
        <div className={style['unassigned-user']}>
          <FormattedMessage defaultMessage='Unassigned' description='assignedUser.unassigned' id='O9bpYt' />
        </div>
      )}
    </div>
  );
};

AssignedUser.propTypes = {
  userId: PropTypes.string,
  className: PropTypes.string,
};
